import { DEFAULT_PAGE_SIZE } from '@/constants'

import type { Pagination, PaginationCallbacks, SearchParams } from './feedTypes'

export class PaginationService {
  async handlePageChange(
    page: number,
    pageSize: number,
    searchParams: SearchParams,
    callbacks: PaginationCallbacks
  ): Promise<void> {
    const {
      setPagination,
      setProductsLoading,
      setPaginatedTableLoading,
      search,
    } = callbacks

    setPagination({
      current: page,
      pageSize,
      total: 0,
    })

    setProductsLoading(true)
    setPaginatedTableLoading(true)

    try {
      await Promise.resolve(
        search({
          query: searchParams.query,
          categories: searchParams.categories,
          brands: searchParams.brands,
          page: page - 1,
          characteristicFilters: searchParams.characteristicFilters,
          withLeftovers: searchParams.withLeftovers,
          triggerNavigation: true,
        })
      )
    } catch (error) {
      console.error('Error during pagination search:', error)
      setProductsLoading(false)
      setPaginatedTableLoading(false)
    }
  }

  getDefaultPagination(): Pagination {
    return {
      current: 1,
      pageSize: DEFAULT_PAGE_SIZE,
      total: 0,
    }
  }
}
